<template>
  <router-view :group="group"
               v-if="group"
               @updated="fetchData">
  </router-view>
</template>
<script>

export default {
  data() {
    return {
      busy: false,
      group: null,
    }
  },
  computed: {
    groupID() {
      console.log(this.$route.params);
      return parseInt(this.$route.params.groupID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.busy = true;
      axios.get(`/api/groups/${this.groupID}`)
          .then(response => {
            this.group = response.data;
          })
          .catch(err => {
            this.$toast.error('Group not found.');
            this.$router.replace({name: 'admin.groups.index'});
          })
          .finally(() => {
            this.busy = false;
          })
    }
  }
}
</script>
